<template>
<div class="dropdowm-list-style">
    <ob-dropdown title="Question Categories" style="margin-left:10px;" class="dropdown fixed-dropdown" v-if="showCategoryDropDown">
        <ob-dropdown-list-item @click.native="onClickCategory(g)" v-for="(g,index) in QuestionCategoryList" :key="index">{{g}}</ob-dropdown-list-item>
    </ob-dropdown>
    <div class="fdnsaudit-container" v-for="(list, lIndex) in QuestionList" :key="lIndex">
        <div class="heading-txt" :id="categoryID(QuestionCategoryList[lIndex])">
            <p>{{QuestionCategoryList[lIndex]}}</p>
        </div>
        <div :id="`${categoryID(QuestionCategoryList[lIndex])}-content`">
            <fdns-question-ans :validate="validate" :qa="q" v-for="(q,index) in list" :qNo="index + 1" :key="`index-${q.Id}`" :OrgId="OrgId" :IsFDNSVisit="IsFDNSVisit" :readOnly="readOnly" :isSelected="isSelected(q)" :searchText="searchText" @onSelect="onSelect" @onUnSelect="onUnSelect" @onSelectedDataChange="onSelectedDataChange" @questiondeleted="onQuestionDeleted(list, ...arguments)" @questionupdated="onQuestionUpdated"></fdns-question-ans>
        </div>
    </div>
</div>
</template>
<script>
import Question from "./Questions.vue";
export default {
  props: {
    QuestionList: {
      required: true
    },
    QuestionCategoryList: {
      required: true
    },
    OrgId: {
      required: false
    },
    IsFDNSVisit: {
      default: false
    },
    selectedData: {
      required: false
    },
    readOnly: {
      default: false
    },
    scrollableDivID: {
      default: "fdnstabcontent"
    },
    scrollableOffsetDiff: {
      default: 200
    },
    validate: {
      default: false
    },
    showCategoryDropDown: {
      default: true
    }
  },
  data() {
    return {
      searchText: ""
    };
  },
  created() {
    this.searchText = __.clone(
      this.$store.getters.getFDNSSearchFilterField("SearchText")
    );
  },
  watch: {
    QuestionList(v) {
      this.searchText = __.clone(
        this.$store.getters.getFDNSSearchFilterField("SearchText")
      );
    }
  },
  components: {
    "fdns-question-ans": Question
  },

  methods: {
    onQuestionUpdated() {
      this.$emit("questionupdated");
    },
    onQuestionDeleted(list, cqa) {
      let index = list.findIndex(l => l.Id == cqa.Id);
      if (index != -1) {
        list.splice(index, 1);
      }
    },
    isSelected(q) {
      let found = false;
      if (this.selectedData && this.selectedData.length > 0) {
        this.selectedData.forEach(s => {
          if (s.Id == q.Id) {
            found = true;
          }
        });
      }
      return found;
    },
    onSelect(d) {
      let arr = __.cloneDeep(this.selectedData);
      let index = arr.findIndex(a => a.Id == d.Id);
      if (index == -1) {
        // not already exists
        arr.push(d);
        this.$emit("update:selectedData", arr);
      }
    },
    onUnSelect(d) {
      let arr = __.cloneDeep(this.selectedData);
      __.remove(arr, obj => obj.Id == d.Id);
      this.$emit("update:selectedData", arr);
    },
    onSelectedDataChange(d) {
      let arr = __.cloneDeep(this.selectedData);
      let index = arr.findIndex(a => a.Id == d.Id);
      arr[index] = d;
      this.$emit("update:selectedData", arr);
    },
    categoryID(name) {
      return __.snakeCase(name);
    },
    onClickCategory(w) {
      this.toScroll(
        document.getElementById(`${this.categoryID(w)}-content`).offsetTop -
          this.scrollableOffsetDiff
      );
    },
    toScroll(scrollTop) {
      let container = document.getElementById(this.scrollableDivID);
      container.scrollTop = scrollTop;
    }
  }
};
</script>

<style lang="scss" scoped>
.fixed-dropdown {
  position: fixed;
  right: 23px;
  top: 215px;
  z-index: 2;
}
.fdnsaudit-container {
  background: #fff;
}
.heading-txt {
  padding: 15px 15px 5px 22px;
  border-bottom: 1px solid #4a90e3;
  position: -webkit-sticky;
  position: sticky;
  top: 0px;
  background: #fff;
  z-index: 1;
  p {
    color: #4a90e3;
    font-size: 14px;
    font-weight: 600;
  }
}
</style>
<style lang="scss">
.dropdowm-list-style {
  .dropdown-list-item {
    font-size: 12px;
  }
  .popper {
    width: 156px;
    left: 25px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ESSProfile/FDNS/QA/List.vue